import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../Contexts/ContextProvider';

const Logout = () => {
 const { logout } = useStateContext();
 const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/', { replace: true });
  }, [logout, navigate]);
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-4xl font-bold mb-4">Goodbye!</h1>
      <p className="text-lg">You have been logged out.</p>
    </div>
  );
};

export default Logout;